import React from 'react';
import SignaturePad from './SignaturePad';
import { supabase } from './supabaseClient';
import { useRef } from 'react';
import { t } from './translations';

const T = { soft:'#8892a4' };

function PBar({steps,cur}){
  return(
    <div className="pgbar">
      {Array.from({length:steps}).map((_,i)=>(
        <div key={i} className={'pbs'+(i<cur?' dn':i===cur?' ac':'')}/>
      ))}
    </div>
  );
}

function PhotoSlot({idx, photos, setPhotos, load, lang}){
  const inputRef = useRef(null);
  const status = photos[idx];
  const handleFile = async (e) => {
    const file = e.target.files[0];
    if(!file) return;
    setPhotos(p=>{const n=[...p];n[idx]='uploading';return n;});
    const ext = file.name.split('.').pop();
    const path = `${load?.loadRef||'unknown'}/delivery_${idx}_${Date.now()}.${ext}`;
    const { error } = await supabase.storage.from('shipment-documents').upload(path, file);
    if(error){
      console.error('خطا در آپلود عکس:', error);
      alert('خطا در آپلود عکس: '+error.message);
      setPhotos(p=>{const n=[...p];n[idx]=null;return n;});
      return;
    }
    setPhotos(p=>{const n=[...p];n[idx]=path;return n;});
  };
  return(
    <div className={'photo-slot'+(status&&status!=='uploading'?' done':'')} onClick={()=>status!=='uploading'&&inputRef.current?.click()}>
      <input ref={inputRef} type="file" accept="image/*" capture="environment" style={{display:'none'}} onChange={handleFile}/>
      {status==='uploading'?(<><div style={{fontSize:20}}>⏳</div><div style={{fontSize:10,color:'#fcd34d'}}>{t(lang,'uploadingLbl')}</div></>)
      :status?(<><div style={{fontSize:20}}>✓</div><div style={{fontSize:10,color:'#86efac',fontWeight:600}}>{t(lang,'photoLbl')} {idx+1}</div></>)
      :(<><div style={{fontSize:20}}>📸</div><div style={{fontSize:10,color:'#4a5568'}}>{t(lang,'photoLbl')} {idx+1}</div></>)}
    </div>
  );
}

export default function DeliveryModal({
  activeLoad, selLoad,
  deliveryStep, setDeliveryStep,
  deliveryOk, setDeliveryOk,
  damageNote, setDamageNote,
  deliveryPhotos, setDeliveryPhotos,
  sigReceiver, setSigReceiver,
  sigReceiverName, setSigReceiverName,
  close, setAvail, setActiveLoad, resetDelivery, completeDelivery, lang
}){
  const load=activeLoad||selLoad;
  const validPhotoCount=(deliveryPhotos||[]).filter(p=>p&&p!=='uploading').length;

  if(deliveryStep===0) return(
    <div>
      <PBar steps={3} cur={0}/>
      <div className="ttl">{t(lang,'deliveryAtDestTitle')}</div>
      <div className="sub">{t(lang,'deliveryAtDestSub')}</div>
      {load&&(
        <div style={{background:'rgba(136,146,164,0.05)',border:'1px solid #232b36',borderRadius:10,padding:11,marginBottom:14}}>
          <div style={{fontSize:11,color:'#e8f01a',fontFamily:'Barlow Condensed',letterSpacing:1}}>REF: {load.loadRef||'—'}</div>
          <div style={{fontSize:13,fontWeight:600,marginTop:4,color:'#93c5fd'}}>{load.from} → {load.to}</div>{load.delivery_address&&<div style={{marginTop:8}}><div style={{fontSize:11,color:'#8892a4'}}>{lang==='de'?'Lieferadresse':'Delivery address'}: <span style={{color:'#e2e8f0',fontWeight:600}}>{load.delivery_address}</span></div><a href={load.delivery_lat&&load.delivery_lng?'https://www.google.com/maps?q='+load.delivery_lat+','+load.delivery_lng:'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(load.delivery_address)} target='_blank' rel='noopener noreferrer' style={{fontSize:11,color:'#93c5fd',textDecoration:'underline'}}>🗺 {lang==='de'?'In Google Maps oeffnen':'Open in Google Maps'}</a></div>}
        </div>
      )}
      <div style={{background:'rgba(59,130,246,0.06)',border:'1px solid rgba(59,130,246,0.2)',borderRadius:10,padding:11,marginBottom:14,fontSize:12,color:'#93c5fd',lineHeight:1.7}}>
        ℹ️ {lang==='de'?'Der Zustand der Ladung wird vom Absender anhand der Fotos geprüft.':'The cargo condition will be reviewed by the sender based on the photos.'}
      </div>
      <div className="sec-lbl">{t(lang,'deliveryPhotosTitle')}</div>
      <div className="photo-grid">
        {(deliveryPhotos||[]).map((_,idx)=>(
          <PhotoSlot key={idx} idx={idx} photos={deliveryPhotos} setPhotos={setDeliveryPhotos} load={load} lang={lang}/>
        ))}
      </div>
      <div style={{fontSize:11,color:T.soft,marginBottom:14}}>{t(lang,'deliveryPhotosSub')}</div>
      <button className="btn ba" disabled={validPhotoCount<2} onClick={()=>setDeliveryStep(1)}>{t(lang,'continueToWarehouseSig')}</button>
      <button className="btn bo" onClick={close}>{t(lang,'laterBtn')}</button>
    </div>
  );

  if(deliveryStep===1) return(
    <div>
      <PBar steps={3} cur={1}/>
      <div className="ttl">{t(lang,'warehouseSigTitle')}</div>
      <div className="sub">{t(lang,'warehouseSigSub')}</div>
      {load?.receiverName&&(
        <div style={{background:'rgba(232,240,26,0.05)',border:'1px solid rgba(232,240,26,0.15)',borderRadius:10,padding:10,marginBottom:13,fontSize:12,color:T.soft}}>
          {t(lang,'receiverSpecifiedPrefix')} <strong style={{color:'#e8f01a'}}>{load.receiverName}</strong>
        </div>
      )}
      <div className="sec-lbl">{t(lang,'warehousePersonNameLbl')}</div>
      <input className="inp" placeholder={t(lang,'senderNamePh')} value={sigReceiverName} onChange={e=>setSigReceiverName(e.target.value)}/>
      <SignaturePad
        label={t(lang,'receiverSigLabel')}
        subLabel={`"${t(lang,'receiverSigConfirmPrefix')} ${sigReceiverName||'...'} ${t(lang,'receiverSigConfirmMiddle')} ${load?.loadRef||''} ${t(lang,'receiverSigConfirmSuffix')}"`}
        onSign={setSigReceiver}
        signed={!!sigReceiver}
        signerName={sigReceiverName}
        lang={lang}
      />
      <button className="btn ba" disabled={!sigReceiver||!sigReceiverName} onClick={()=>setDeliveryStep(2)}>{t(lang,'finalConfirmBtn')}</button>
      <button className="btn bo" onClick={()=>setDeliveryStep(0)}>{t(lang,'backBtn')}</button>
    </div>
  );

  if(deliveryStep===2) return(
    <div>
      <PBar steps={3} cur={2}/>
      <div className="ctr">
        <div className="success-ico">✓</div>
        <div className="ttl">{t(lang,'deliverySuccessTitle')}</div>
        <div className="sub">
          {lang==='de'?'Die Lieferung wurde erfasst. Der Absender wird den Zustand der Ladung prüfen und bestätigen.':'The delivery has been recorded. The sender will review and confirm the cargo condition.'}
        </div>
      </div>
      <div className="pb">
        {[
          [t(lang,'loadNumberLbl'),load?.loadRef||'—'],
          [t(lang,'warehouseSigSummaryLbl'),'✓ '+sigReceiverName],
          [t(lang,'timeWord'),new Date().toLocaleString()],
        ].map(([k,v])=>(<div key={k} className="prow" style={{marginBottom:7}}><span style={{fontSize:11,color:T.soft}}>{k}</span><span style={{fontSize:11,fontWeight:600,color:'#f1f5f9'}}>{v}</span></div>))}
      </div>
      <button className="btn ba" onClick={()=>{completeDelivery(load?.loadRef);setActiveLoad(null);resetDelivery();close();}}>{t(lang,'closeFileBtn')}</button>
    </div>
  );
  return null;
}
